<template>
    <section class="container" style="position: relative">
        <transition name="bounce">
            <div v-if="isCopy" class="alert alert-success" role="alert">
                <span>{{ copy[lang()] }}</span><!--  -->
            </div>
        </transition>
        <div class="row ttt">
            <div class="col-md-12 contacts_left_block">
                <span style="font-size: 1.5rem;">+380991044900</span>
                <b-button 
                    class="mail-btn"
                    variant="info"
                    @click="copiMail"
                >
                    funbaseua@gmail.com
                </b-button>
                <span>
                    <a href=" https://instagram.com/funbaseua" target="_blank">
                        <img src="../assets/instagram.png" style="width: 50px">
                    </a>
                </span>
            </div>
        </div>
    </section>
</template>

<script>
import { store } from '../store.js'
import axios from 'axios';
export default {
    data () {
        return {
            isCopy: false
        }
    },
    methods: {
        lang() {
            return localStorage.getItem('lang');
        },
        copiMail() {
            window.navigator.clipboard.writeText('funbaseua@gmail.com')
                .then(() => {
                    this.isCopy = true;
                    setTimeout(() => this.isCopy = false, 2000)
                })
        }
    },
    computed: {
        copy() {
            return store.copyMail
        }
    }
}

</script>

<style>
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.mail-btn {
    margin: 1rem;
}
.alert {
    text-align: center;
    position: absolute;
    width: 100%;
    top: 2rem;
}
.mail_spinner {
    float: right;
}
.contacts_left_block {
    text-align: center;
}
.contacts_left_block > span {
    display: block;
    margin-bottom: 1rem;
}
.contacts_left_block:last-child {
    max-width: 80%;
    margin-left: 10%;
}
.ttt {
    display: flex;
    align-items: center;
    height: calc(100vh - 10vh);
}
.prices_container  > h5 {
    text-align: center;
}
.mail_block {
    position: relative;
}
.mail_block > button{
    float: right;
}
.mail_block > input {
    margin-bottom: 1rem;
}
.mail_block > label {
    margin-bottom: 0.2rem !important;
}
.mail_block > textarea {
    margin-bottom: 1rem;
}

@media (max-width: 767px) {
    .mail_block {
        margin-bottom: 3rem;
    }
    .alert {
        position: absolute;
        z-index: 999;
        top: 15vh;
        left: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Contacts.vue